<template>
  <div
    v-if="open"
    :class="{
      'menu-dropdown': true,
      'menu-dropdown--sticked': computedScrollPosition > 0,
    }"
    :style="{
      top: `${pTop}px`,
      'max-height': `${maxHeight}px`,
      width: `calc(100% - ${scrollWidth}px)`,
    }"
    v-click-outside-bemob="onClickOutside"
  >
    <slot name="select" :scrollPosition="computedScrollPosition"></slot>

    <div :class="dropdownClass">
      <template v-for="(item, index) in items" :key="index">
        <slot name="item" v-bind="item"></slot>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { $emitter } from '@/services/emitter';

const props = withDefaults(
  defineProps<{
    open?: boolean;
    top?: number;
    items?: Record<string, unknown>[];
    dropdownClass?: string;
  }>(),
  {
    open: false,
    top: 0,
    items: () => [],
    dropdownClass: '',
  },
);

const emit = defineEmits<{
  'click-outside': [];
}>();

const scrollPosition = ref(document.body.scrollTop);
const scrollWidth = ref(0);
const lastSource = ref('body');

const getMaxHeight = () => {
  const windowHeight = document.documentElement.clientHeight;
  return windowHeight - props.top;
};

const maxHeight = ref(getMaxHeight());

const computedScrollPosition = computed(() => props.top - scrollPosition.value + 1);
const pTop = computed(() => props.top);

const onClickOutside = () => {
  emit('click-outside');
};

const updateScrollPosition = (source: string = lastSource.value) => {
  if (source === 'body') {
    scrollPosition.value = document.body.scrollTop;
  } else if (source === 'window') {
    scrollPosition.value = document.documentElement.scrollTop;
  }

  lastSource.value = source;
};

const onBusBodyScrolled = (source: string) => {
  if (props.open) {
    updateScrollPosition(source);
  }
};

const onBusWindowResized = () => {
  maxHeight.value = getMaxHeight();
};

watch(
  () => props.open,
  (value) => {
    if (value) {
      updateScrollPosition();
      maxHeight.value = getMaxHeight();
    }
  },
);

watch(
  () => props.top,
  (value) => {
    if (value) {
      scrollWidth.value = document.body.offsetWidth - document.body.clientWidth;
      updateScrollPosition();
    }
  },
);

onMounted(() => {
  $emitter.on('body-scrolled', onBusBodyScrolled);
  $emitter.on('window-resized', onBusWindowResized);
});

onBeforeUnmount(() => {
  $emitter.off('body-scrolled', onBusBodyScrolled);
  $emitter.off('window-resized', onBusWindowResized);
});
</script>

<style lang="scss">
.menu-dropdown {
  &--sticked {
  }
}
</style>
